import type { RootState } from '../types/store';
import getActiveEcommerceSubscriptionType from './active-ecommerce-subscription-type';
import getEcommercePlans from './ecommerce-plans';
import messenger from '../messenger';
import type { EcommercePlan } from '../types/ecommerce-plan';

function getCurrentEcommercePlan(state: RootState): EcommercePlan | null {
  const activeEcommerceSubscriptionType = getActiveEcommerceSubscriptionType(state);
  const ecommercePlans = getEcommercePlans(state);

  if (!ecommercePlans) throw new Error(messenger.missingData('ecommercePlans'));

  if (!activeEcommerceSubscriptionType) return null;

  return {
    ...ecommercePlans[activeEcommerceSubscriptionType],
    type: activeEcommerceSubscriptionType,
  };
}

export default getCurrentEcommercePlan;
